
import { Component, Vue } from 'nuxt-property-decorator'
import JoinPreview from '~/components/join/JoinPreview.vue'
import JoinForm from '~/components/join/JoinForm.vue'
import JoinSuccess from '~/components/join/JoinSuccess.vue'

// @ts-ignore
@Component({
  components: { JoinSuccess, JoinForm, JoinPreview },
  // @ts-ignore
  amp: 'hybrid',
  ampLayout: 'amp'
})
export default class extends Vue {
  /**  @member {number} joinStep - 0: start; 1: registration form; 2: success */
  joinStep: number = 0

  head () {
    return {
      title: this.$t('head.title.join'),
      meta: [
        { hid: 'description', name: 'description', content: this.$t('head.description.join') },
        { hid: 'og:title', name: 'og:title', content: this.$t('head.title.join') },
        { hid: 'og:description', name: 'og:description', content: this.$t('head.description.join') },
        { hid: 'og:image', name: 'og:image', content: require('~/assets/img/logo-black.svg') },
        { hid: 'og:type', name: 'og:type', content: 'website' },
        { hid: 'og:url', name: 'og:url', content: process.env.API_ENDPOINT + this.$route.fullPath }
      ]
    }
  }
}
